module.exports = __webpack_public_path__ + "static/media/renekaj.27114dbf.jpg";